var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-select',{model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}},_vm._l((_vm.labels),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item,"text":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }